import React from "react";

const iconLayouts = color => ({
  calenderButton: (
    <svg
          style={{
            cursor: "pointer",
          }}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.25 5V17.5C1.25 17.8315 1.3817 18.1495 1.61612 18.3839C1.85054 18.6183 2.16848 18.75 2.5 18.75H17.5C17.8315 18.75 18.1495 18.6183 18.3839 18.3839C18.6183 18.1495 18.75 17.8315 18.75 17.5V5H1.25ZM2.5 1.25C1.83696 1.25 1.20107 1.51339 0.732233 1.98223C0.263392 2.45107 0 3.08696 0 3.75L0 17.5C0 18.163 0.263392 18.7989 0.732233 19.2678C1.20107 19.7366 1.83696 20 2.5 20H17.5C18.163 20 18.7989 19.7366 19.2678 19.2678C19.7366 18.7989 20 18.163 20 17.5V3.75C20 3.08696 19.7366 2.45107 19.2678 1.98223C18.7989 1.51339 18.163 1.25 17.5 1.25H2.5Z"
            fill="var(--icon-color)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.375 0C4.54076 0 4.69973 0.065848 4.81694 0.183058C4.93415 0.300269 5 0.45924 5 0.625V1.25C5 1.41576 4.93415 1.57473 4.81694 1.69194C4.69973 1.80915 4.54076 1.875 4.375 1.875C4.20924 1.875 4.05027 1.80915 3.93306 1.69194C3.81585 1.57473 3.75 1.41576 3.75 1.25V0.625C3.75 0.45924 3.81585 0.300269 3.93306 0.183058C4.05027 0.065848 4.20924 0 4.375 0V0ZM15.625 0C15.7908 0 15.9497 0.065848 16.0669 0.183058C16.1842 0.300269 16.25 0.45924 16.25 0.625V1.25C16.25 1.41576 16.1842 1.57473 16.0669 1.69194C15.9497 1.80915 15.7908 1.875 15.625 1.875C15.4592 1.875 15.3003 1.80915 15.1831 1.69194C15.0658 1.57473 15 1.41576 15 1.25V0.625C15 0.45924 15.0658 0.300269 15.1831 0.183058C15.3003 0.065848 15.4592 0 15.625 0V0Z"
            fill="var(--icon-color)"
          />
        </svg>
  ),
});

const DateTimeIcon = ({ onClick, className, type }) => {
  const icon = iconLayouts()[type];
  return <span>{icon}</span>;
};

export default DateTimeIcon;
